import { post, get } from './http-client';
import { getStoredTokenData } from './token-storage';

const cardEntryUrl = CARD_ENTRY_URL + '/public/card-payment-service/v1';

export const validatePaymentSession = ({ validationUrl, invoice }, customHeaders) => {
  return post(`${cardEntryUrl}/payment/apple-pay/payment-session`, { validationUrl, invoice }, customHeaders);
};

export const storeApplePayToken = (paymentToken) => {
  return post('/api/apple-pay/store-token', {
    payment_token: JSON.stringify(paymentToken),
  });
};

export const associateTokenIdWithUser = async () => {
  const tokenData = getStoredTokenData();
  if (tokenData && tokenData.tokenId) {
    return post('/api/apple-pay/associate-token', {
      token_id: tokenData.tokenId,
    });
  }
};

export const getApplePayPaymentToken = async () => {
  const tokenData = getStoredTokenData();
  if (!tokenData || !tokenData.tokenId) return null;
  const { data } = await get('/api/apple-pay/get-token', { token_id: tokenData.tokenId });
  return JSON.parse(data.payment_token);
};

export const isApplePayOneClickFeatureEnabled = async () => {
  const { enabled } = await get('/api/feature-flag/by-name/pb-exchange-form-apple-pay-one-click');

  return enabled;
};
